export default __webpack_public_path__ + "static/media/RangeSelect.15d60e35.svg";